import UniqueId from '../../services/uid/UniqueId';
import { AppState } from '../reducers/root';
import { CatalogsStateEntity } from '../slices/catalogs';

export const getCatalogsStateEntity = (
  state: AppState,
  catalogId: UniqueId
): CatalogsStateEntity => state.catalogs[catalogId];

export const isCatalogConnectedWithForm = (
  state: AppState,
  catalogId: UniqueId
): boolean => state.catalogs[catalogId].formId === catalogId;
